import React from 'react';
import { Badge } from 'reactstrap';

const Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Status = (cell) => {
    return (
        <Badge
            className={"font-size-12 badge-soft-" + (cell.value === true ? "success" : "danger")}
        >
            {cell.value == true ? "Aktif" : "Pasif"}
        </Badge>
    );
};

export {
    Name,
    Status
};
